// AI Generated Test
import { Component, Output, EventEmitter } from '@angular/core';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { FormFeedbackComponent } from '@client/app/forms/feedback/feedback.component';

@Component({
    selector: 'form-global-policy-exchange-center',
    templateUrl: './exchange-center.html',
    standalone: false,
})
export class FormGlobalPolicyExchangeCenterComponent {
    @Output() chooseTemplate = new EventEmitter<any>();

    constructor (
        private monEventService: MonEventService,
    ) {}

    onChooseTemplate (template: any) {
        this.chooseTemplate.emit({ template });
    }

    suggestPolicy () {
        const params = {
            body: FormFeedbackComponent,
        };
        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }
}
